import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from "react-router-dom";

import useAsync from '../hooks/useAsync';
import { Link } from 'react-router-dom';
import LinkForm from './Button/Link.js'
import UserServices from '../services/UserServices';
import StateServices from '../services/StateServices';
import ViewUser from './View Model/ViewUser';
import Modal from 'react-modal';
import UserStatus from './TogelButton/UserStatus';
import UpdateProfile from './Update Model/UpdateProfile.js';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import Select, { components } from 'react-select';
Modal.setAppElement('#root');

// Guard so District and Police Station APIs are called only once (avoids duplicate from Strict Mode / re-renders)
let initialFiltersFetched = false;

function UserManager() {
  const [currentPage, setCurrentPage] = useState(1);  // State to track the current page
  const [search, setSearch] = useState('');
  const [data1, setData1] = useState();
  const [data, setData] = useState();
  const [temp, setTemp] = useState(0);
  const usersPerPage = 50;  // You can adjust this value as needed
  const [filteredData, setFilteredData] = useState();
  const [statusFilter, setStatusFilter] = useState('');
  const [verifiedFilter, setVerifiedFilter] = useState('');
  const [districtFilter, setDistrictFilter] = useState('');
  const [policeStationFilter, setPoliceStationFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  const [districts, setDistricts] = useState([]);
  const [policeStations, setPoliceStations] = useState([]);
  const location = useLocation();
  const [filterReady, setFilterReady] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get("status");
    const verified = params.get("verified");

    if (status) {
      setStatusFilter(status);
    } else if (verified) {
      setVerifiedFilter(verified);
    }

    setFilterReady(true);
  }, [location.search]);

  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  }, [search, statusFilter, verifiedFilter, districtFilter, policeStationFilter, dateFilter]);
  useEffect(() => {
    if (!filterReady) return;

    UserServices.getAllUser(
      currentPage,
      search,
      statusFilter,
      verifiedFilter,
      districtFilter,
      policeStationFilter,
      dateFilter || undefined
    )
      .then((res) => setData(res))
      .catch((error) => console.log(error));
  }, [
    filterReady,
    currentPage,
    search,
    statusFilter,
    verifiedFilter,
    districtFilter,
    policeStationFilter,
    dateFilter,
    temp
  ]);

  // useEffect(() => {
  //   UserServices.getAllUser(currentPage, search, statusFilter, verifiedFilter, districtFilter, policeStationFilter).then((res) => {
  //     setData(res)
  //   }).catch((error) => {
  //     console.log(error)
  //   })
  // }, [currentPage, search, statusFilter, verifiedFilter, districtFilter, policeStationFilter, temp])



  // Fetch districts and police stations once on mount (guarded to prevent duplicate calls from Strict Mode / re-renders)
  useEffect(() => {
    if (initialFiltersFetched) return;
    initialFiltersFetched = true;

    const fetchFilters = async () => {
      try {
        const [districtRes, stationRes] = await Promise.all([
          StateServices.getDistrict('66addcf6a38d0ef6027318ea'),
          StateServices.getUttarakhandPoliceStations(),
        ]);
        const districtsData = districtRes.data || [];
        const stationsData = stationRes.data || [];
        const uniqueDistricts = districtsData.filter((district, index, self) =>
          index === self.findIndex((d) => d._id === district._id)
        );
        const uniqueStations = stationsData.filter((station, index, self) =>
          index === self.findIndex((s) => s._id === station._id)
        );
        setDistricts(uniqueDistricts);
        setPoliceStations(uniqueStations);
      } catch (error) {
        console.error('Failed to fetch districts or police stations', error);
        initialFiltersFetched = false; // allow retry on error
      }
    };
    fetchFilters();
  }, []);
  // useEffect(() => {
  //   const fetchData = () => {
  //     UserServices.getAllUser(currentPage)
  //       .then(res => setData(res))
  //       .catch(err => console.error(err));
  //   };
  //   fetchData();
  // }, [currentPage]);

  // useEffect(() => {
  //   if (search) {
  //     UserServices.getAllUserSearch(search)
  //       .then(res => setFilteredData(res))
  //       .catch(err => console.error(err));
  //   } else {
  //     setFilteredData(data);
  //   }
  // }, [search, data]);
  // // console.log(">>>", data)
  const count = data?.totalProfiles;  // Total profiles count


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const [selectedLink, setSelectedLink] = useState(null);

  const isAddressFieldEqual = (a, b) => {
    if (a === b) return true;
    if (!a || !b) return false;
    const normalize = (val) => {
      if (typeof val === 'object') {
        if (val._id) return val._id.toString();
        if (val.name) return val.name.toString();
      }
      return val.toString();
    };
    return normalize(a) === normalize(b);
  };
  const handleEditDetails = (thana) => {
    setSelectedEdit(thana);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };
  // const handleLinkDetails = (user) => {
  //   setSelectedLink(user);
  //   setIsLinkModalOpen(true);
  //   toggleActionMenu(null);
  // };
  const handleLinkDetails = (user) => {
    const userId = user?._id;
    const { presentAddress = {}, permanentAddress = {} } = user || {};

    const isMatching = ["mohalla", "state", "district", "policeStation", "pinCode"].every(
      (field) => isAddressFieldEqual(presentAddress[field], permanentAddress[field])
    );

    const encodedUserId = btoa(userId);
    const generatedLink = isMatching
      ? `https://pehchan.accredipath.com/match-form/${encodedUserId}`
      : `https://pehchan.accredipath.com/form/${encodedUserId}`;

    // const encodedUserId = btoa(userId);
    // const generatedLink = isMatching
    //   ? `http://localhost:3000/match-form/${encodedUserId}`
    //   : `http://localhost:3000/form/${encodedUserId}`;

    // Open the generated link in a new tab
    window.open(generatedLink, '_blank');
  };

  const closeLinkModal = () => {
    setIsLinkModalOpen(false);
    setSelectedLink(null);
  };
  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);  // Update current page state
  };
  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    return `${day}-${month}-${year}`;
  };


  // Format districts for react-select (unique by _id)
  const districtOptions = useMemo(() => {
    const uniqueDistricts = districts.filter((district, index, self) =>
      index === self.findIndex((d) => d._id === district._id)
    );
    return uniqueDistricts.map(district => ({
      value: district._id,
      label: district.name
    }));
  }, [districts]);

  // Format police stations for react-select (unique by _id, filtered by district)
  const policeStationOptions = useMemo(() => {
    let filteredStations = policeStations;

    // Filter by district if selected
    if (districtFilter) {
      filteredStations = policeStations.filter((station) => {
        const stationDistrictId = station.district?._id || station.district;
        return stationDistrictId === districtFilter || stationDistrictId?.toString() === districtFilter;
      });
    }

    // Remove duplicates based on _id
    const uniqueStations = filteredStations.filter((station, index, self) =>
      index === self.findIndex((s) => s._id === station._id)
    );

    return uniqueStations.map(station => ({
      value: station._id,
      label: station.name
    }));
  }, [policeStations, districtFilter]);

  // Get selected values for react-select
  const selectedDistrict = useMemo(() =>
    districtOptions.find(opt => opt.value === districtFilter) || null,
    [districtOptions, districtFilter]
  );

  const selectedPoliceStation = useMemo(() =>
    policeStationOptions.find(opt => opt.value === policeStationFilter) || null,
    [policeStationOptions, policeStationFilter]
  );

  // Get selected district and police station names for name-based matching
  const selectedDistrictName = useMemo(() =>
    selectedDistrict?.label || null,
    [selectedDistrict]
  );

  const selectedPoliceStationName = useMemo(() =>
    selectedPoliceStation?.label || null,
    [selectedPoliceStation]
  );

  // Data is now filtered on the backend, so we just use the data directly
  const filteredUsers = data?.data || [];

  const handleDownload = () => {
    const downloadUrl = `${process.env.REACT_APP_API_BASE_URL}/profile/download-excel${search ? `?search=${search}` : ''}`;
    window.location.href = downloadUrl;
  };

  const handleDownloadProfile = () => {
    const downloadUrl = UserServices.downloadProfile(search, statusFilter, verifiedFilter, districtFilter, policeStationFilter, dateFilter);
    window.location.href = downloadUrl;
  };
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };


  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Satyapan <span className="badge bg-warning">{count}</span></h2>
        <div className="title-box-actions">
          <button className="excel-btn" onClick={handleDownload}><img src="img/excel.svg" alt="" />Download</button>
          {/* <button className="download-profile-btn" onClick={handleDownloadProfile}>
            Download Profile
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: 6 }}>
              <path d="M2 4L5 7L8 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button> */}
        </div>
      </div>
      <div className="container-box px-0 user-manager">
        <div className="container-box-top-header px-4">
          <div className="container-box-top-header-left-2">
            <input
              type="search"
              name="search"
              placeholder="Search"
              value={search}
              onChange={handleSearchChange}
            />
            <button className="search-btn">Search</button>

            {/* Verified Filter Dropdown */}
            <select
              className="filter-dropdown"
              value={verifiedFilter}
              onChange={(e) => setVerifiedFilter(e.target.value)}
            >
              <option value="">All Verified</option>
              <option value="Valid">Valid</option>
              <option value="Invalid">Invalid</option>
            </select>

            {/* Status Filter Dropdown */}
            <select
              className="filter-dropdown"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="Verify">Verify</option>
              <option value="UnVerify">UnVerify</option>
            </select>

            {/* Date Filter */}
            <input
              type="date"
              className="filter-dropdown filter-date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
              style={{ height: '34px', borderRadius: '6px', border: '1px solid #E5E7EB' }}
            />

            {/* District Filter Dropdown - Searchable */}
            <div style={{ minWidth: '135px', flex: '0 0 135px', display: 'inline-block' }}>
              <Select
                value={selectedDistrict}
                onChange={(selectedOption) => {
                  setDistrictFilter(selectedOption ? selectedOption.value : '');
                  setPoliceStationFilter(''); // Reset police station when district changes
                }}
                options={districtOptions}
                placeholder="All Districts"
                isSearchable
                isClearable
                components={{
                  Input: (props) => <components.Input {...props} placeholder={props.selectProps.menuIsOpen ? "Search districts..." : ""} />,
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '34px',
                    height: '34px',
                    fontSize: '13px',
                    border: '1px solid #E5E7EB',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    boxShadow: 'none',
                    backgroundColor: '#fff',
                    '&:hover': {
                      border: '1px solid #D1D5DB'
                    }
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    padding: '0 8px',
                    height: '32px',
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    color: '#333',
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: '#333',
                    fontWeight: 500,
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: '#333',
                    fontWeight: 500,
                  }),
                  indicatorSeparator: () => ({
                    display: 'none',
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    padding: '0 6px',
                    color: '#6B7280',
                  }),
                  clearIndicator: (base) => ({
                    ...base,
                    padding: '0 4px',
                    color: '#9CA3AF',
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                    border: '1px solid #E5E7EB',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    borderRadius: '6px',
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: '13px',
                    padding: '8px 12px',
                    backgroundColor: state.isSelected ? '#2563EB' : state.isFocused ? '#F3F4F6' : '#fff',
                    color: state.isSelected ? '#fff' : '#333',
                    cursor: 'pointer',
                  }),
                }}
              />
            </div>

            {/* Police Station Filter Dropdown - Searchable */}
            <div style={{ minWidth: '135px', flex: '0 0 135px', display: 'inline-block' }}>
              <Select
                value={selectedPoliceStation}
                onChange={(selectedOption) => {
                  setPoliceStationFilter(selectedOption ? selectedOption.value : '');
                }}
                options={policeStationOptions}
                placeholder="All Police Stations"
                isSearchable
                isClearable
                isDisabled={!districtFilter && false}
                components={{
                  Input: (props) => <components.Input {...props} placeholder={props.selectProps.menuIsOpen ? "Search police stations..." : ""} />,
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '34px',
                    height: '34px',
                    fontSize: '13px',
                    border: '1px solid #E5E7EB',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    boxShadow: 'none',
                    backgroundColor: '#fff',
                    '&:hover': {
                      border: '1px solid #D1D5DB'
                    }
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    padding: '0 8px',
                    height: '32px',
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    color: '#333',
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: '#333',
                    fontWeight: 500,
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: '#333',
                    fontWeight: 500,
                  }),
                  indicatorSeparator: () => ({
                    display: 'none',
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    padding: '0 6px',
                    color: '#6B7280',
                  }),
                  clearIndicator: (base) => ({
                    ...base,
                    padding: '0 4px',
                    color: '#9CA3AF',
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                    border: '1px solid #E5E7EB',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    borderRadius: '6px',
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: '13px',
                    padding: '8px 12px',
                    backgroundColor: state.isSelected ? '#2563EB' : state.isFocused ? '#F3F4F6' : '#fff',
                    color: state.isSelected ? '#fff' : '#333',
                    cursor: 'pointer',
                  }),
                }}
              />
            </div>
          </div>

        </div>
        <div className="container-box-inner">
          <table id="example" className="table" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>#</th>
                <th>App User</th>
                <th>Satyapan Name</th>
                <th>Aadhar No.</th>
                <th>Mobile No.</th>
                <th>Profession</th>
                <th>State</th>
                <th>District</th>
                <th>Police Station</th>
                <th>Verification ID</th>
                <th>Register Date</th>
                {/* <th>Status Label</th> */}
                <th>Status</th>
                <th>More Details</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers?.map((user, index) => (
                <tr key={user?._id} className={user?.status === 'Verify' ? 'row-verified' : 'row-unverified'}>
                  <td style={{ whiteSpace: 'nowrap', width: '40px' }}>
                    {index + 1 + (currentPage - 1) * usersPerPage}
                  </td>
                  <td>
                    <span>{user?.user?.name}</span>
                  </td>
                  <td>
                    {user?.name}
                  </td>
                  <td>
                    {user?.aadharNo}
                  </td>
                  <td>
                    {user?.mobileNo}
                  </td>
                  <td>
                    {user?.profession?.profession || 'N/A'}
                  </td>
                  <td>
                    {user?.presentState?.name || 'N/A'}
                  </td>
                  <td>
                    {user?.presentDistrict?.name || 'N/A'}
                  </td>
                  <td>
                    {user?.presentPoliceStation?.name || 'N/A'}
                  </td>
                  <td>
                    {[user?.presentPoliceStation?.code, user?.verificationId, user?.presentDistrict?.code]
                      .filter(Boolean).join(' ') || 'N/A'}
                  </td>
                  <td>
                    {formatDate(user?.createdAt)}
                  </td>
                  <td className="status-toggle"><UserStatus user={user} page={"user"} /></td>
                  <td>
                    <div className="action_toggle_outer">
                      <button
                        className="action_toggle"
                        onClick={() => toggleActionMenu(index)}
                      >
                        <i className="fa fa-ellipsis-v" />
                      </button>
                      {activeIndex === index && (
                        <div className="action_toggle_content product-edit show d-block">
                          <ul className="list-unstyled">
                            <li>
                              <button className="edit" onClick={() => handleEditDetails(user)}>Edit</button>
                            </li>
                            <li>
                              <button className="view-details-btn" onClick={() => handleViewDetails(user)}>View</button>
                            </li>
                            <li>
                              <button className="edit" onClick={() => handleLinkDetails(user)}>Print</button>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil(count / usersPerPage)}  // Total pages
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}  // Page change handler
            containerClassName={'pagination'}
            activeClassName={'active'}
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            initialPage={currentPage - 1}
            pageLinkClassName={'page-link'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            disabledClassName={'disabled'}
          />
        </div>
      </div>
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        contentLabel="Edit Category"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <UpdateProfile selectedData={selectedEdit} closeModal={closeEditModal} onSuccess={() => setTemp(temp + 1)} />
      </Modal>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewUser user={selectedUser} closeModal={closeModal} />
      </Modal>
      {/* <Modal
        isOpen={isLinkModalOpen}
        onRequestClose={closeLinkModal}
        contentLabel="Link Category"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <LinkForm user={selectedLink} closeModal={closeLinkModal} />
      </Modal> */}
    </div>
  )
}
export default UserManager;


